/*
*
* In use in the setup guide
*
 */

(function() {
    "use strict";

    Directives.TrialTextDirective = function TrialTextDirective() {

        // @ngInject
        function TrialTextControllerConstructor($scope, $injector, UsersManager, OnboardingService, SetupGuideService, ModalService, $state, AppStates, CompaniesManager, PricingPlansService) {

            this.constructor.$super.call(this, $scope, $injector);
            this._objectType = 'TrialTextController';

            this.OnboardingService = OnboardingService;
            this.SetupGuideService = SetupGuideService;
            this.ModalService = ModalService;
            this.$state = $state;
            this.AppStates = AppStates;
            this.CompaniesManager = CompaniesManager;
            this.PricingPlansService = PricingPlansService;

            this.currUser  = UsersManager.getCurrUser();
            this.company = CompaniesManager.getCurrCompany();
            this.isCompanyOwner = this.currUser.isCompanyOwner();
            this.subscriptionDiscountValue = 0;
            if(this.isCompanyOwner) {
                this.PricingPlansService.getAvailablePricingPlans(this.company).then(function gotAvailablePricingPlans(plans) {
                    if (plans.length > 0) {
                        this.referrer = plans[0]._referrer_name;
                        this.subscriptionDiscountValue = calculatePercentage(plans[0].amount, plans[0].original_amount)
                    }

                }.bind(this));
            }

            function calculatePercentage(newAmount, originalAmount) {
                if (originalAmount > 0) {
                    return ((originalAmount - newAmount)  * 100) / originalAmount;
                }
                return 0;
            }
        }

        var TrialTextController = Class(Controllers.BaseController, {
            constructor: TrialTextControllerConstructor,

            shouldShowTrialText: function shouldShowTrialText() {
                return this.OnboardingService.showOnboardingBar();
            },

            onUpgradeNow: function onUpgradeNow() {
                if (angular.isFunction(this.onUpgrade)) {
                    this.onUpgrade();
                }
            },

            getDaysTillTrialEnds: function getDaysTillTrialEnds() {
                return this.currUser && this.currUser.nTillTrialEnds();
            },


        });

        return {
            scope: {
                className: '@',
                onUpgrade: '&',
            },
            templateUrl: 'angular/app/modules/common/ui_components/trial_text/trial_text_template.html',
            controller: TrialTextController,
            controllerAs: 'trialTextVm',
            bindToController: true
        };

    }

}());